export default __webpack_public_path__ + "static/media/emoji-smileSick.36a04581.svg";